import { isApiError, shouldShowApiErrorToast } from '../api/errors'
import type { ToastShowOptions, ToastVariant } from '../context/ToastContext'

type ShowToast = (options: ToastShowOptions) => void

/** 统一 API 错误 Toast：401 / 已全局处理的鉴权错误不再重复提示 */
export function showApiErrorToast(
  showToast: ShowToast,
  error: unknown,
  fallback: string,
  variant: ToastVariant = 'error',
): void {
  if (!shouldShowApiErrorToast(error)) return
  const message = isApiError(error)
    ? error.message
    : error instanceof Error
      ? error.message
      : fallback
  showToast({ message: message || fallback, variant })
}
